
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meta-muse-image-ai-generator",
      function () {
        return require("private-next-pages/meta-muse-image-ai-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/meta-muse-image-ai-generator"])
      });
    }
  